import React from "react"
import { connect } from "react-redux"
import { segueToSearch } from "search-new/action-creators"
import StatCell from "sheets/components/cells/StatCell"
import Tooltip from "app/static/frontend/components/Tooltip"

import { searchStatCellConnection } from "sheets/selectors/column-selectors"

export const SearchStatCell = ({
    allowSegueToSearch, // whether we should allow users to segue to search from the Sheet
    children,
    searchDataType,
    segueToSearch,
    segueToSearchArgs,
    ...props
}) => {
    if (allowSegueToSearch) {
        return (
            <span className="search-count-cell">
                <Tooltip label={`View all of these ${searchDataType} in search`}>
                    <StatCell className="search-count-cell" {...props} onClick={() => segueToSearch(segueToSearchArgs)}>
                        {children}
                    </StatCell>
                </Tooltip>
            </span>
        )
    }
    return <StatCell {...props}>{children}</StatCell>
}

export default connect((state, props) => searchStatCellConnection(state, props), { segueToSearch })(SearchStatCell)
